import 'regenerator-runtime/runtime';
import { call, put, select } from 'redux-saga/effects';

import API, { methods } from '../canvas-api';

import { handleGenericError, getAuthState } from '../common';
import { actions } from '../../reducers/onboarding/onboarding';

export default function* startTask(action) {
  try {
    const { identifier } = action.payload;

    // persist task initiation in back end
    const { userId } = yield select(getAuthState);
    const response = yield call(API, {
      method: methods.POST,
      path: `users/${userId}/onboarding/task/${identifier}/start`,
    });
    if (response === null) return;
    yield put(actions.startTaskSuccess());
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
